import ImmersalBinaryPath from '../assets/content/map/95026-sydunisculpture.bytes';
import ImmersalSparsePath from '../assets/content/map/95026-sydunisculpture-sparse.ply';
import ImmersalDensePath from '../assets/content/map/95026-sydunisculpture-dense.ply';
import ImmersalTexturedPath from '../assets/content/map/95026-sydunisculpture-tex.glb';
//
import { MainBase } from './main.app.base';
import { AppImmersalConfig } from './eyejack-web-core/src/apps/app.immersal';
import ContentEmpty from './content/content.empty';

export class MainSydUniSculpture extends MainBase {

  constructor() {
    const configImmersal = new AppImmersalConfig({
      token: '0d9e70de2e6dad37060de2019f11f272c00fc6087fbecf803a4cffec2b24b01c',
      localizeOnDevice: false,
      maps: [
        {
          mapId: 95026,
          binaryMapPath: ImmersalBinaryPath,
          sparseMapPath: ImmersalSparsePath,
          denseMapPath: ImmersalDensePath,
          texturedMapPath: ImmersalTexturedPath,
          pointCloudSize: 5,
        },
      ],
    });
    super(configImmersal, new ContentEmpty());
  }
}

//----------------------------------------------------------------
const app = new MainSydUniSculpture();
app.init();